<template>
  <div class="container py-5 text-center text-muted">
    <p class="mb-0">Redirecting to login…</p>
  </div>
</template>

<script>
import { PARTNER_PUBLIC_LOGIN_URL } from "@/utils/partnerPublicLoginUrl";

export default {
  name: "PartnerPublicLoginRedirect",
  mounted() {
    window.location.replace(PARTNER_PUBLIC_LOGIN_URL);
  },
};
</script>
